import { TextArea as BaseTextArea } from '@kvdbil/components';
import { TextAreaProps as BaseTextAreaProps } from '@kvdbil/components/types/components/TextArea';
import React, { RefObject } from 'react';
import {
  Control,
  Controller,
  Path,
  PathValue,
  RegisterOptions,
  UnpackNestedValue
} from 'react-hook-form';

type ControllerBaseValue = string | number | readonly string[] | undefined;
type TextFieldProps<FormState> = Omit<BaseTextAreaProps, 'value'> & {
  control: Control<FormState>;
  name: Path<FormState>;
  rules?: RegisterOptions;
  defaultValue?: UnpackNestedValue<
    PathValue<FormState, (string | undefined) & Path<FormState>>
  >;
};

const Input = React.forwardRef((props: BaseTextAreaProps, ref) => (
  <BaseTextArea {...props} forwardRef={ref as RefObject<HTMLInputElement>} />
));

const TextAreaWithControl = <FormState,>(props: TextFieldProps<FormState>) => {
  return (
    <Controller
      {...props}
      render={({ field, fieldState }) => {
        return (
          <Input
            {...props}
            {...field}
            value={field.value as ControllerBaseValue}
            errors={[fieldState.error?.message ?? '']}
            hasError={Boolean(fieldState.error)}
          />
        );
      }}
    />
  );
};

export default TextAreaWithControl;
